import {
  type EnvironmentSettings,
  getEnvironmentSettings,
  useFetchAppSettings,
} from '@festina-life/authentication'
import type { Optional } from '@festina-life/core'
import { useMemo } from 'react'

type ConfigurationEnvironment = EnvironmentSettings & {
  REACT_APP_DOCUMENTATION_URL?: string
}

export const useConfigurationDocuSiteUrl = (): Optional<string> => {
  const { data: appSettings } = useFetchAppSettings()

  return useMemo(() => {
    if (appSettings) {
      const [currentSettings] = getEnvironmentSettings(appSettings)
      const configurationSettings = currentSettings as ConfigurationEnvironment

      return configurationSettings.REACT_APP_DOCUMENTATION_URL
    }

    return null
  }, [appSettings])
}
